export const italian = {
  home: {
    titolo: "Il modulo delle segnalazioni",
    introduzione1: "Il presente modulo non può essere utilizzato per le comunicazioni utili ai fini dell’esercizio del potere sanzionatorio della Autorità, relativamente ad operatori economici nei cui confronti sussistono cause di esclusione ex art. 80 del d.lgs. 18 aprile 2016, n. 50, nonché per le notizie, le informazioni dovute dalle stazioni appaltanti ai fini della tenuta del casellario informatico. Per tali comunicazioni si rinvia al",
    introduzione1B: "Il presente modulo non può essere utilizzato per la segnalazione di illeciti di interesse generale in qualità di whistleblower. Per tali segnalazioni si invita a consultare il servizio dedicato al link: ",
    introduzione2: "Il modulo delle segnalazioni è una sezione del portale dell’Autorità che consente agli utenti di:",
    list_item1: "Individuare il modulo da utilizzare in funzione dell’ambito e della fattispecie oggetto della segnalazione",
    list_item2: "Compilare on line il modulo",
    list_item3: "Inviare via web la segnalazione e, a protocollazione avvenuta, ricevere una mail con indicazione del numero di pratica, della data e del numero di protocollo.",
    introduzione3: "Dopo la richiesta dei dati identificativi iniziali del segnalante il modulo richiede l’individuazione dell’area a cui afferisce la segnalazione, distinguendo tra:",
    list_item4: {
      titolo: "Contratti pubblici: ",
      desc1: "quest’area è deputata alla ricezione di tutte le segnalazioni che riguardano violazioni della disciplina sull’affidamento e l’esecuzione di contratti pubblici di lavori, servizi e forniture, sia che si tratti di appalti sia che si tratti di concessioni. Confluiscono in quest’area anche tutte le segnalazioni riferite a: partenariato pubblico privato; finanza di progetto; in house;  centrali di committenza; ",
      desc2: "conflitti di interesse nello svolgimento delle procedure di aggiudicazione di appalti e concessioni; ",
      desc3: "contratti secretati; affidamenti a contraente generale."
    },
    list_item5: {
      titolo: "Anticorruzione: ",
      desc: "quest’area è deputata alla ricezione di tutte le segnalazioni volte all’attivazione dei poteri di vigilanza dell’Autorità inerenti alla verifica delle misure di prevenzione della corruzione, con particolare riferimento all’adozione dei Piani triennali di prevenzione della corruzione e della trasparenza (PTPCT) e alla nomina del Responsabile della prevenzione della corruzione e della trasparenza (RPCT)."
    },
    list_item6: {
      titolo: "Conferimento incarichi e imparzialità: ",
      desc: "quest’area è deputata alla ricezione di tutte le segnalazioni che riguardano casi di inconferibilità, incompatibilità, mancata attivazione delle misure di prevenzione dei conflitti di interesse all’interno dell’ente o relative al contenuto dei codici di comportamento, secondo quanto meglio descritto nell’area specifica."
    },
    list_item7: {
      titolo: "Trasparenza: ",
      desc: "quest’area è deputata alla ricezione di tutte le segnalazioni riferite al mancato rispetto degli obblighi di pubblicazione e trasparenza individuati dalla legge 190/2012 e dal d.lgs. 33/2013."
    }
  },
  buttons: {
    prosegui: "Prosegui",
    proseguiSPID: "Prosegui con autenticazione"
  },
  info: {
    alert1: "Attenzione: Alcuni servizi per l'autocompletamento non sono disponibili. L'indisponibilità dei servizi di autocompletamento non preculde il corretto invio della segnalazione.",
    alert2: "L'applicazione non è momentaneamente disponibile, si prega di accedere più tardi.",
    alert3: "Recupero dei dati dal salvataggio del giorno "
  },
  salvato_in_bozza: "Dati salvati in bozza",
  cf_non_trovato: "CODICE FISCALE NON TROVATO",
  denominazione: "Denominazione:",
  cf: "Codice Fiscale:",
  localizzazione: "Localizzazione:",
  natura_giuridica: "Natura Giuridica:",
  stazione_appaltante: "Stazione Appaltante",
  oggetto_gara: "Oggetto della gara:",
  importo_complessivo: "Importo Complessivo:",
  cig: "CIG",
  end: {
    info1: "La segnalazione è stata inviata con successo.",
    info2: "A breve riceverà alla mail indicata per il contatto, una copia pdf della sottomissione.",
    info3: "Protocollo:",
    downloadPDF: "Scarica Documento in PDF"
  },
  "complete": "Sottomissione completa",
  "cancel": "Cancella",
  "next": "Avanti",
  "previous": "Sezione Precedente",
  "submit": "Invia e completa la sottomissione",
  "Drop files to attach,": "Aggiungere i file spostandoli in quest'area,",
  "or": "oppure",
  "browse": "cliccare qui e cercare il file da allegare",
  "No choices to choose from": "nessuna selezione disponibile",
  "Type to search": "testo da cercare",
  "Add Another": "Aggiungi",
  "File Name": "Nome del file",
  "Please save all rows before proceeding.": "Cliccare sul tasto 'salva' prima di procedere",
  "File is the wrong type; it must be {{ pattern }}": "Tipo di file non accettato. I tipi di file accetati sono {{ pattern }}",
  "File is too big; it must be at most {{ size }}": "Il file è troppo grande. La dimensione massima è {{ size }}",
  "Invalid row. Please correct it or delete.": "Riga non valida. Correggere o cancellare.",
  "Please correct invalid rows before proceeding.": "Correggere le righe non valide prima di procedere",
  "Size": "Dim.",
  "Save": "Salva",
  "Cancel": "Cancella",
  "Edit": "Modifica",
  "Delete": "Cancella",
  "Yes:": "Sì",
  "No": "No",
  "Day": "giorno",
  "Month": "mese",
  "Year": "anno",
  "january": "Gennaio",
  "february": "Febbraio",
  "march": "Marzo",
  "april": "Aprile",
  "may": "Maggio",
  "june": "Giugno",
  "july": "Luglio",
  "august": "Agosto",
  "september": "Settembre",
  "october": "Ottobre",
  "november": "Novembre",
  "december": "Dicembre"
}
